import React, { cloneElement } from 'react';
import {
  Button,
  Col,
  Row,
  Form,
  Table,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
} from 'reactstrap';
import axios from 'axios';
import StorageService from '../services/StorageService';
import { MdDone, MdClear, MdCreate, MdSearch } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import { BsPlusSquareFill } from 'react-icons/bs';
import { IconContext } from 'react-icons/lib';
import CrmCategoryForm from './CrmCategoryForm';

class CrmCategoryTable extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isLoadong: true,
      modal: false,
      confirmModal: false,
      redirect: false,
      categoryList: [],
      selectedId: '',
      selectedData: '',
    };
  }

  componentDidMount() {
    this.getCategoryList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getCategoryList();
    }
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      category_id: this.state.selectedId,
      delete_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/category/delete', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Category deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        this.getCategoryList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getCategoryList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/category', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            categoryList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    const categoryList = this.state.categoryList.map(item => {
      return (
        <tr key={item.id}>
          <td>{item.name}</td>
          <td>
            <div className="ps-action-button">
              <Button
                className="theme-button theme-button-secondary"
                onClick={this.toggle('EDIT', item.id)}
              >
                Edit
              </Button>
              <Button
                className="theme-button theme-button-primary-light"
                onClick={this.toggleConfirmModal(item.name, item.id)}
              >
                Delete
              </Button>
            </div>
          </td>
        </tr>
      );
    });
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <div className="text-right mb-3">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>

        <Table responsive hover className="ps-table tb-col-2 th-no-wrap">
          <thead>
            <tr>
              <th>Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {categoryList.length < 1 ? (
              <tr>
                <td colSpan="7">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>
                        Click the {this.state.isGlobal ? 'Create' : 'Add'}{' '}
                        button to add new address
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              categoryList
            )}
          </tbody>
        </Table>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <CrmCategoryForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
            customerData={this.props.data}
          />
        </Modal>

        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            {this.state.isGlobal ? 'Delete' : 'Remove'} Category
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to{' '}
                  {this.state.isGlobal ? 'delete' : 'remove'}{' '}
                  {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              No
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default CrmCategoryTable;
